export var EventNames = {
    TESTS_REQUEST_SENT: "ab-testing-tests-request-sent",
    TESTS_REQUEST_RECEIVED: "ab-testing-tests-request-received",
    FOOCMASK_ACTIVED: "ab-testing-fooc-mask-actived",
    FOOCMASK_DEACTIVATED: "ab-testing-fooc-mask-deactivated",
    FOOCMASK_TIMEDOUT: "ab-testing-fooc-mask-timedout",
    MBOX_RENDERED: "ab-testing-mbox-rendered",
    RENDER_ERROR: "ab-testing-render-error",
    MBOX_MANIFEST_USED: "ab-testing-mbox-manifest-used"
};

//# sourceMappingURL=events.js.map